module.exports = __webpack_public_path__ + "img/logo.7dfa6355.svg";